"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_audit_service_client_js_1 = require("@synisys/idm-audit-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var subway_model_1 = require("./model/subway.model");
var services_1 = require("../../services");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
require("./sis-subway-map.component.scss");
var Subject_1 = require("rxjs/Subject");
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var store_1 = require("@ngrx/store");
/**
 * @author Kadmos.Balkhchyan on 12/16/2019
 */
var SubwayMapComponent = /** @class */ (function () {
    function SubwayMapComponent(auditService, classifierService, formattingService, actionService, messageService, currentLanguageProvider, store) {
        var _this = this;
        this.auditService = auditService;
        this.classifierService = classifierService;
        this.formattingService = formattingService;
        this.actionService = actionService;
        this.messageService = messageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.store = store;
        this.ACTION_WORKFLOW = 'audit_service.action.workflow';
        this.ACTION_CREATE = 'audit_service.action.create';
        this.USER_SYSTEM_NAME = 'User';
        this.ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
        this.ONE_HOUR_IN_MS = 60 * 60 * 1000;
        this.ONE_MINUTE_IN_MS = 60 * 1000;
        this.MESSAGE_KEYS = [
            'subway_map.wf_action_date_message',
            'subway_map.wf_action_by_message',
            'subway_map.wf_passed_time_message',
            'subway_map.duration_days_message.short',
            'subway_map.duration_hours_message.short',
            'subway_map.duration_minutes_message.short',
            'subway_map.wf_action_name_message',
        ];
        this.translateSize = 284;
        this.moveSize = 0;
        this.initialSpace = 40;
        this.destroy$ = new Subject_1.Subject();
        this.loadWfActionsAndAuditData = function (_a) {
            var metaField = _a[0], metaCategory = _a[1];
            return Observable_1.Observable.zip(_this.loadCreateActionAuditData(), _this.loadWfActionAuditData(), Observable_1.Observable.of(metaField), _this.actionService.getActionsByProcessId(metaCategory.wfProcessId));
        };
        this.loadCreateActionAuditData = function () {
            var initialFilterAuditItem = new idm_audit_service_client_js_1.FilterAuditItem(_this.entity.getInstanceId(), _this.categoryName, undefined, _this.ACTION_CREATE, undefined, undefined, undefined, undefined, undefined, idm_audit_service_client_js_1.Order.ASC);
            return _this.auditService.getAuditItems(initialFilterAuditItem);
        };
        this.loadWfActionAuditData = function () {
            var filterAuditItem = new idm_audit_service_client_js_1.FilterAuditItem(_this.entity.getInstanceId(), _this.categoryName, undefined, _this.ACTION_WORKFLOW, undefined, undefined, undefined, undefined, undefined, idm_audit_service_client_js_1.Order.ASC);
            return _this.auditService.getAuditItems(filterAuditItem);
        };
        this.loadClassifiers = function (_a) {
            var initialAuditItems = _a[0], auditItems = _a[1], metaField = _a[2], actions = _a[3];
            var userIds = new Set();
            var wfStateIds = new Set();
            var allAuditItems = initialAuditItems.concat.apply(initialAuditItems, auditItems);
            allAuditItems.forEach(function (auditItem) {
                userIds.add(auditItem.userId);
                wfStateIds.add(auditItem.data[metaField.metaFieldId.systemName]);
            });
            if (allAuditItems.length === 0) {
                return Observable_1.Observable.of();
            }
            _this.currentState =
                allAuditItems[allAuditItems.length - 1].data[metaField.metaFieldId.systemName];
            var entityWfState = _this.entity.getProperty(metaField.metaFieldId.systemName).value.getId();
            if (_this.entity && entityWfState !== _this.currentState) {
                _this.currentState = entityWfState;
            }
            wfStateIds.add(_this.currentState);
            var futureActions = actions.filter(function (action) {
                var isFiltered = action.getInitialStateId() === _this.currentState;
                if (isFiltered) {
                    wfStateIds.add(action.getTargetStateId());
                }
                return isFiltered;
            });
            return Observable_1.Observable.zip(Observable_1.Observable.of(allAuditItems), Observable_1.Observable.of(metaField), Observable_1.Observable.of(futureActions), Observable_1.Observable.of(actions), _this.classifierService.loadClassifiersByIds(_this.USER_SYSTEM_NAME, Array.from(userIds)), _this.classifierService.loadClassifiersByIds(metaField.workflowStateMetaCategoryId.systemName, Array.from(wfStateIds)), Observable_1.Observable.from(_this.messageService.getMessages(_this.currentLanguageId, _this.MESSAGE_KEYS)));
        };
        this.transformData = function (_a) {
            var auditItems = _a[0], metaField = _a[1], futureActions = _a[2], actions = _a[3], users = _a[4], wfStates = _a[5], messages = _a[6];
            var usersMap = new Map();
            var wfStatesMap = new Map();
            _this.usedMessages = messages;
            users.getData().forEach(function (user) {
                usersMap.set(user.getId(), _this.classifierService.getEntityName(_this.USER_SYSTEM_NAME, user));
            });
            wfStates.getData().forEach(function (wfState) {
                wfStatesMap.set(wfState.getId(), _this.classifierService.getEntityName(metaField.workflowStateMetaCategoryId.systemName, wfState));
            });
            var lastActionFieldSystemName = idm_kb_service_client_js_1.KbHttpService.WORKFLOW_ACTION_ID_SYSTEM_NAME;
            var actionsNamesMap = new Map();
            actions.forEach(function (action) {
                actionsNamesMap.set(action.getId(), action.getName());
            });
            var subwayData = auditItems.map(function (auditItem, index) {
                var duration;
                if (index < auditItems.length - 1) {
                    duration =
                        auditItems[index + 1].modifiedDate -
                            auditItem.modifiedDate;
                }
                else {
                    duration = new Date().valueOf() - auditItem.modifiedDate;
                }
                var lastActionId = auditItem.data[lastActionFieldSystemName];
                return new subway_model_1.SubwayModel(wfStatesMap.get(auditItem.data[metaField.metaFieldId.systemName]), usersMap.get(auditItem.userId), _this.formattingService.formatDateTime(auditItem.modifiedDate), _this.formatDuration(duration), lastActionId ? actionsNamesMap.get(lastActionId) : undefined);
            });
            if (auditItems[auditItems.length - 1].data[metaField.metaFieldId.systemName] !== _this.currentState) {
                var actionId = Number(_this.entity.getProperty(lastActionFieldSystemName).value);
                subwayData.push(new subway_model_1.SubwayModel(wfStatesMap.get(_this.currentState), Observable_1.Observable.of(''), Observable_1.Observable.of(''), '', actionId ? actionsNamesMap.get(actionId) : undefined));
            }
            return [
                subwayData,
                futureActions.map(function (action) {
                    return wfStatesMap.get(action.getTargetStateId());
                }),
            ];
        };
    }
    SubwayMapComponent.prototype.ngOnInit = function () {
        if (this.entity && this.entity.getInstanceId()) {
            this.loadWfStateAuditData();
        }
        this.initActionNotifier();
        this.loadCurrentLanguage();
    };
    SubwayMapComponent.prototype.ngOnDestroy = function () {
        this.resetWfSubscription();
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    SubwayMapComponent.prototype.subwayInit = function () {
        var childReallySize = this.subwayMap.nativeElement.offsetWidth + this.initialSpace;
        if (childReallySize > this.subwayContainer.nativeElement.offsetWidth) {
            this.contFixed = true;
            this.showPrevButton = true;
        }
    };
    SubwayMapComponent.prototype.subwayResize = function () {
        this.noTransition = false;
        if (!this.subwayMap || !this.subwayContainer) {
            return;
        }
        var childElement = this.subwayMap.nativeElement.getBoundingClientRect();
        var parentElement = this.subwayContainer.nativeElement.getBoundingClientRect();
        this.leftDiff =
            childElement.left - this.initialSpace - parentElement.left;
        this.rightDiff =
            childElement.right + this.initialSpace - parentElement.right;
        var childReallySize = this.subwayMap.nativeElement.offsetWidth + this.initialSpace;
        if (childReallySize > this.subwayContainer.nativeElement.offsetWidth &&
            !this.showNextButton) {
            this.contFixed = true;
            this.showPrevButton = true;
        }
        else if (childReallySize > this.subwayContainer.nativeElement.offsetWidth &&
            this.showNextButton) {
            this.showPrevButton = true;
            if (this.isRtl) {
                if (this.rightDiff <= 0) {
                    this.moveSize -= this.rightDiff;
                    this.showPrevButton = false;
                    this.noTransition = true;
                }
            }
            else {
                if (this.leftDiff >= 0) {
                    this.moveSize -= this.leftDiff;
                    this.showPrevButton = false;
                    this.noTransition = true;
                }
            }
        }
        else {
            this.contFixed = false;
            this.showPrevButton = false;
            this.showNextButton = false;
            this.moveSize = 0;
        }
    };
    SubwayMapComponent.prototype.prevClicked = function () {
        this.showNextButton = true;
        this.noTransition = false;
        if (this.isRtl) {
            this.moveSize += -this.translateSize;
        }
        else {
            this.moveSize += this.translateSize;
        }
        var childElement = this.subwayMap.nativeElement.getBoundingClientRect();
        var parentElement = this.subwayContainer.nativeElement.getBoundingClientRect();
        /**
         * if subway map moved to the left hiding prev button and moving transition to the end
         */
        if (this.isRtl) {
            if (childElement.right - this.translateSize <=
                parentElement.right) {
                this.showPrevButton = false;
                this.moveSize =
                    this.subwayContainer.nativeElement.offsetWidth -
                        this.subwayMap.nativeElement.offsetWidth -
                        this.initialSpace;
            }
        }
        else {
            if (childElement.left + this.translateSize >= parentElement.left) {
                this.showPrevButton = false;
                this.moveSize =
                    this.subwayMap.nativeElement.offsetWidth -
                        this.subwayContainer.nativeElement.offsetWidth +
                        this.initialSpace;
            }
        }
    };
    SubwayMapComponent.prototype.nextClicked = function () {
        this.noTransition = false;
        this.showPrevButton = true;
        if (this.isRtl) {
            this.moveSize += this.translateSize;
            if (this.moveSize >= 0) {
                this.showNextButton = false;
                this.moveSize = 0;
            }
        }
        else {
            this.moveSize -= this.translateSize;
            if (this.moveSize <= 0) {
                this.showNextButton = false;
                this.moveSize = 0;
            }
        }
    };
    SubwayMapComponent.prototype.onResize = function () {
        this.subwayResize();
    };
    SubwayMapComponent.prototype.loadCurrentLanguage = function () {
        var _this = this;
        this.currentLanguageProvider.getCurrentLanguage().subscribe(function (language) {
            _this.isRtl = language.getDirection() === idm_crosscutting_concepts_frontend_1.LanguageDirection.RTL;
        }, function (err) { return console.error(err); });
    };
    SubwayMapComponent.prototype.resetWfSubscription = function () {
        if (this.wfSubscription) {
            this.wfSubscription.unsubscribe();
            this.wfSubscription = undefined;
        }
    };
    SubwayMapComponent.prototype.loadWfStateAuditData = function () {
        var _this = this;
        this.resetWfSubscription();
        this.wfSubscription = Observable_1.Observable.zip(this.getWorkflowStateMetaField(this.categoryName), skynet_store_kb_api_1.categoryStoreManager(this.containerType).selectOne(this.store, this.categoryName))
            .pipe(operators_1.switchMap(this.loadWfActionsAndAuditData), operators_1.switchMap(this.loadClassifiers), operators_1.map(this.transformData))
            .subscribe(function (_a) {
            var wfStateData = _a[0], futureStateData = _a[1];
            _this.wfStateData = wfStateData;
            _this.futureStateData = futureStateData;
            setTimeout(function () {
                _this.subwayInit();
            }, 0);
        }, console.error);
    };
    SubwayMapComponent.prototype.formatDuration = function (duration) {
        duration = Math.abs(duration);
        var days = Math.floor(duration / this.ONE_DAY_IN_MS);
        var hours = Math.floor((duration - days * this.ONE_DAY_IN_MS) / this.ONE_HOUR_IN_MS);
        // round to upper number for including seconds
        var minutes = Math.round((duration -
            days * this.ONE_DAY_IN_MS -
            hours * this.ONE_HOUR_IN_MS) /
            this.ONE_MINUTE_IN_MS);
        var formattedDuration = '';
        if (days !== 0) {
            formattedDuration = formattedDuration.concat(days + " " + this.usedMessages.get(this.MESSAGE_KEYS[3]) + " ");
        }
        if (hours !== 0) {
            formattedDuration = formattedDuration.concat(hours + " " + this.usedMessages.get(this.MESSAGE_KEYS[4]) + " ");
        }
        if (minutes !== 0) {
            formattedDuration = formattedDuration.concat(minutes + " " + this.usedMessages.get(this.MESSAGE_KEYS[5]));
        }
        if (formattedDuration.length === 0) {
            formattedDuration = "1 " + this.usedMessages.get(this.MESSAGE_KEYS[5]);
        }
        return formattedDuration;
    };
    SubwayMapComponent.prototype.initActionNotifier = function () {
        var _this = this;
        if (this.actionNotifier !== undefined) {
            this.actionNotifier
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe(function (saveEventData) {
                if (_this.entity &&
                    _this.entity.getInstanceId() &&
                    (saveEventData.key === 3 || saveEventData.key === 1)) {
                    _this.loadWfStateAuditData();
                }
            }, console.error);
        }
    };
    SubwayMapComponent.prototype.getWorkflowStateMetaField = function (categorySystemName) {
        return skynet_store_kb_api_1.fieldStoreManager(this.containerType)
            .selectAll(this.store, categorySystemName)
            .pipe(operators_1.map(function (metaFields) {
            return metaFields.find(function (metaField) {
                return metaField.metaFieldType === 'WORKFLOW_STATE';
            });
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], SubwayMapComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SubwayMapComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SubwayMapComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], SubwayMapComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SubwayMapComponent.prototype, "containerType", void 0);
    __decorate([
        core_1.ViewChild('subwayContainer'),
        __metadata("design:type", core_1.ElementRef)
    ], SubwayMapComponent.prototype, "subwayContainer", void 0);
    __decorate([
        core_1.ViewChild('subwayMap'),
        __metadata("design:type", core_1.ElementRef)
    ], SubwayMapComponent.prototype, "subwayMap", void 0);
    __decorate([
        core_1.HostListener('window:resize'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SubwayMapComponent.prototype, "onResize", null);
    SubwayMapComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-subway-map',
            template: require('./sis-subway-map.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n             <sis-subway-map [entity]=\"entity\"\n                             [categoryName]=\"category\"\n                             [currentLanguageId]=\"currentLanguageId\"\n                             [actionNotifier]=\"actionNotifier\"\n                             [containerType]=\"containerType\">\n             </sis-subway-map>",
            isSubwayMap: true,
            name: 'Subway Map',
            nameKey: 'de.controls.subway_map.title',
        }),
        __metadata("design:paramtypes", [idm_audit_service_client_js_1.AuditService,
            idm_classifier_service_client_js_1.ClassifierService,
            services_1.FormattingService,
            idm_workflow_service_client_js_1.ActionService,
            idm_message_language_service_client_js_1.MessageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            store_1.Store])
    ], SubwayMapComponent);
    return SubwayMapComponent;
}());
exports.SubwayMapComponent = SubwayMapComponent;
//# sourceMappingURL=sis-subway-map.component.js.map